import React from 'react';
import { useNavigate } from 'react-router-dom';

function ThankYouPage({ handleLogout }) {
  const navigate = useNavigate();

  const handleExit = () => {
    if (handleLogout) {
      handleLogout();
    }
    navigate('/');
  };

  return (
    <div className="page-container">
      <h1>Спасибо за участие в эксперименте!</h1>
      <p>Ваши ответы были успешно записаны.</p>
      <button onClick={handleExit}>Вернуться на главную</button>
    </div>
  );
}

export default ThankYouPage;